import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOArticleSection from './components/SEOArticleSection';
import FeaturedGrid from './components/FeaturedGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

const siteUrl: string = import.meta.env.VITE_SITE_URL;

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'KakobuySpreadsheet',
      url: siteUrl,
      description: 'Kakobuy Spreadsheet to kompleksowy arkusz zakupowy ułatwiający wyszukiwanie produktów. Odkryj kategorie, poradniki zakupowe, porównania arkuszy i bezpieczne zakupy online.',
      inLanguage: 'pl',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'KakobuySpreadsheet',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <JsonLd data={homeSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <SEOArticleSection />
      <FeaturedGrid />
      <Testimonials />
      <CTASection />
      <Footer />
    </main>
  );
}